export var EMultipleChoiceVariants;
(function (EMultipleChoiceVariants) {
    EMultipleChoiceVariants["List"] = "list";
    EMultipleChoiceVariants["Card"] = "card";
})(EMultipleChoiceVariants || (EMultipleChoiceVariants = {}));
